var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCanada(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14804_65855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0719 0H45.9187V45H14.0625L14.0719 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.84692 0H14.0718V45H-1.84692V0ZM45.9187 0H61.8374V45H45.9281L45.9187 0ZM18.8437 21.75L17.5968 22.1625L23.3531 27.225C23.7937 28.5094 23.2031 28.8937 22.8281 29.5687L29.0718 28.7812L28.9218 35.0625L30.225 35.0344L29.9343 28.7906L36.1875 29.5406C35.8031 28.725 35.4562 28.2937 35.8125 26.9906L41.5593 22.2094L40.5562 21.8344C39.7312 21.1969 40.9125 18.7781 41.0812 17.25C41.0812 17.25 37.7343 18.4031 37.5187 17.7938L36.6562 16.1531L33.6 19.5094C33.2718 19.5938 33.1312 19.4625 33.0468 19.1813L34.4531 12.1688L32.2218 13.425C32.0343 13.5094 31.8468 13.4344 31.7343 13.2188L29.5781 8.90625L27.3656 13.3875C27.1968 13.5469 27.0281 13.5656 26.8968 13.4531L24.75 12.2625L26.0343 19.2094C25.9312 19.4906 25.6875 19.5656 25.4062 19.4156L22.4812 16.1063C22.1062 16.7156 21.8437 17.7094 21.3375 17.9344C20.8312 18.15 19.1343 17.5125 18 17.2781C18.3937 18.6656 19.5937 20.9906 18.8437 21.75Z",
    fill: "#D52B1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14804_65855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanada);
export default __webpack_public_path__ + "static/media/canada.6b78018ea8065b8ff1320246dfc7caed.svg";
export { ForwardRef as ReactComponent };